import axios from "axios";
import Session from "./../session";

var instance = axios.create({
  baseURL: window.location.origin,
});

export default {
  namespaced: true,
  state: {
    ///master dealer
    masterDealer: [],
    masterDealerLoading: false,
    filteredMasterDealer: {
      smartBalance: 0,
      bayadBalance: 0,
      totalBalance: 0,
      earmarked: 0,
    },

    /// retailer
    submitting: false,
    loading: false,
    retailers: [],
    smartBalance: [],
    filteredRetailers: [],
    selectedRetailer: {},
    showRetailerSidebar: false,
    showTopUpRetailerSidebar: false,
    showSettingsSidebar: false,
    showTransactionsSidebar: false,
    showBundleSidebar: false,
    showSmartSidebar: false,
    filter: {
      keyword: "",
    },

    /// sub retailer
    subRetailerLoading: false,
    subRetailerSubmitting: false,
    subRetailers: [],
    subRetailer: {
      subRetailerID: 0,
      retailerID: 0,
      transactionType: "",
      name: "",
      remainingBalance: 0,
      earMarked: 0,
      rebate: 0,
      agentRate: 0,
      dealerRate: 0,
      sureloadRate: 0,
    },
    filteredSubRetailers: [],
    selectedSubRetailer: {},
    showSubRetailerSidebar: false,
    showSubRetailerBalanceSidebar: false,
    subRetailerFilter: {
      keyword: "",
    },

    /// sub retailer users
    subRetailerUsersLoading: false,
    subRetailerUsersSubmitting: false,
    subRetailerUsers: [],
    selectedSubRetailerUser: {},
    showSubRetailerUserSidebar: false,
    showSubRetailerUserDetailSidebar: false,
    showSubRetailerUserBalanceSidebar: false,
    filteredSubRetailersUser: [],
    subRetailerUserFilter: {
      keyword: "",
    },

    /// transactions
    allTransactions: [],
    allTransactionsLoading: [],
    transactions: [],
    transactionsLoading: false,
    bayadTransactions: [],
    bayadTransactionsLoading: false,
    bayadTransactionsCurrentPage: 1,
    bayadTransactionsExportLoading: false,
    bayadTransactionsFilter: {
      dateRange: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
    },
    transactionsExportLoading: false,
    transactionsCurrentPage: 1,
    transactionsFilter: {
      dateRange: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      type: "",
    },

    // topups
    topUps: [],
    topUpsLoading: false,
    topUpsExportLoading: false,
    topUpsFilter: {
      dateRange: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
    },

    /// load subscriber
    showLoadSubscriberSidebar: false,
    loadSubscriberSubmitting: false,
    loadSubscriber: {
      category: "0",
      elpKeyword: "0",
      amount: 0,
      mobileNumbers: "",
    },
  },
  getters: {
    selectedRetailer(state) {
      return state.selectedRetailer;
    },
    selectedSubRetailer(state) {
      return state.selectedSubRetailer;
    },
    selectedSubRetailerUser(state) {
      return state.selectedSubRetailerUser;
    },
    transactionsFilter(state) {
      let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        state.transactionsFilter.dateRange[0]
      );
      let monthFrom = new Intl.DateTimeFormat("en", {
        month: "2-digit",
      }).format(state.transactionsFilter.dateRange[0]);
      let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        state.transactionsFilter.dateRange[0]
      );
      var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

      let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        state.transactionsFilter.dateRange[1]
      );
      let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        state.transactionsFilter.dateRange[1]
      );
      let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        state.transactionsFilter.dateRange[1]
      );
      var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

      return {
        dateFrom: dateFrom,
        dateTo: dateTo,
        type: state.transactionsFilter.type,
      };
    },
    bayadTransactionsFilter(state) {
      let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        state.bayadTransactionsFilter.dateRange[0]
      );
      let monthFrom = new Intl.DateTimeFormat("en", {
        month: "2-digit",
      }).format(state.bayadTransactionsFilter.dateRange[0]);
      let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        state.bayadTransactionsFilter.dateRange[0]
      );
      var dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

      let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        state.bayadTransactionsFilter.dateRange[1]
      );
      let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        state.bayadTransactionsFilter.dateRange[1]
      );
      let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        state.bayadTransactionsFilter.dateRange[1]
      );
      var dateTo = `${yearTo}-${monthTo}-${dayTo}`;

      return {
        dateFrom: dateFrom,
        dateTo: dateTo,
      };
    },
    loadSubscriber(state) {
      return state.loadSubscriber;
    },
    topUpsFilter(state) {
      const [from, to] = state.topUpsFilter.dateRange;

      let yearFrom = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        from
      );
      let monthFrom = new Intl.DateTimeFormat("en", {
        month: "2-digit",
      }).format(from);
      let dayFrom = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
        from
      );
      const dateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

      let yearTo = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
        to
      );
      let monthTo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
        to
      );
      let dayTo = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(to);
      const dateTo = `${yearTo}-${monthTo}-${dayTo}`;

      return {
        dateFrom,
        dateTo,
        ...state.topUpsFilter,
      };
    },
    subRetailer(state) {
      return state.subRetailer;
    },
  },
  mutations: {
    SET_MasterDealer(state, payload) {
      state.masterDealer = payload;
    },
    SET_MasterDealerLoading(state, value) {
      state.masterDealerLoading = value;
    },
    SET_Transactions(state, value) {
      state.transactions = value;
      state.transactionsCurrentPage = 1;
    },
    SET_TransactionsLoading(state, value) {
      state.transactionsLoading = value;
    },
    SET_BayadTransactions(state, value) {
      state.bayadTransactions = value;
    },
    SET_BayadTransactionsLoading(state, value) {
      state.bayadTransactionsLoading = value;
    },
    SET_BayadTransactionsCurrentPage(state, value) {
      state.bayadTransactionsCurrentPage = value;
    },
    SET_BayadTransactionsExportLoading(state, value) {
      state.bayadTransactionsExportLoading = value;
    },
    SET_AllTransactions(state, data) {
      state.allTransactions = data;
    },
    SET_AllTransactionsLoading(state, status) {
      state.allTransactionsLoading = status;
    },
    SET_TransactionsExportLoading(state, value) {
      state.transactionsExportLoading = value;
    },
    SET_TransactionsCurrentPage(state, value) {
      state.transactionsCurrentPage = value;
    },
    SET_LoadSubscriberSubmitting(state, value) {
      state.loadSubscriberSubmitting = value;
    },
    TOGGLE_ShowLoadSubscriberSidebar(state, value) {
      state.showLoadSubscriberSidebar = value;
      state.loadSubscriber = {
        category: "0",
        elpKeyword: "0",
        amount: 0,
        mobileNumbers: "",
      };
    },

    SET_ShowSettingsSidebar(state, value) {
      state.showSettingsSidebar = value;
    },
    SET_ShowTransactionsSidebar(state, value) {
      state.showTransactionsSidebar = value;
    },
    SET_ShowBundleSidebar(state, value) {
      state.showBundleSidebar = value;
    },
    SET_ShowSmartSidebar(state, value) {
      state.showSmartSidebar = value;
    },
    TOGGLE_ShowRetailerSidebar(state, value) {
      state.showRetailerSidebar = value;
    },
    TOGGLE_ShowRetailerTopUpSideBar(state, value) {
      state.showRetailerTopUpSideBar = value;
    },
    SET_Submitting(state, value) {
      state.submitting = value;
    },
    SET_Loading(state, value) {
      state.loading = value;
    },
    SET_SelectedRetailer(state, payload) {
      state.selectedRetailer = payload;
    },
    SET_SubRetailerLoading(state, value) {
      state.subRetailerLoading = value;
    },
    SET_SubRetailerUsersLoading(state, value) {
      state.subRetailerUsersLoading = value;
    },
    SET_Retailers(state, payload) {
      state.retailers = payload;
    },
    SET_SmartBalance(state, payload) {
      state.smartBalance = payload;
    },
    SET_ShowSubRetailer(state, value) {
      state.showSubRetailer = value;
    },
    SET_SubRetailers(state, payload) {
      state.subRetailers = payload;
    },
    SET_SubRetailerUsers(state, payload) {
      state.subRetailerUsers = payload;
    },
    SET_ShowRetailerTopUpSidebar(state, value) {
      state.showTopUpRetailerSidebar = value;
    },
    SELECT_Retailer(state, payload) {
      const returnedTarget = Object.assign({}, payload);
      state.selectedRetailer = returnedTarget;
    },
    FILTER_MasterDealers(state) {
      state.filteredMasterDealer = state.masterDealer;
    },
    FILTER_Retailers(state) {
      state.filteredRetailers = state.retailers;
    },
    FILTER_SubRetailers(state) {
      var keyword = state.subRetailerFilter.keyword;

      state.filteredSubRetailers = state.subRetailers.filter((m) =>
        m.name.includes(keyword)
      );
    },
    FILTER_SubRetailersUser(state) {
      var keyword = state.subRetailerUserFilter.keyword;

      state.filteredSubRetailersUser = state.subRetailerUsers.filter((m) =>
        m.name.includes(keyword)
      );
    },
    SET_ShowSubRetailerSidebar(state, value) {
      state.showSubRetailerSidebar = value;
    },
    SET_ShowSubRetailerBalanceSidebar(state, value) {
      state.showSubRetailerBalanceSidebar = value;
    },
    SET_ShowSubRetailerUserSidebar(state, value) {
      state.showSubRetailerUserSidebar = value;
    },
    SET_ShowSubRetailerUserBalanceSidebar(state, value) {
      state.showSubRetailerUserBalanceSidebar = value;
    },
    SET_ShowSubRetailerUserDetailSidebar(state, value) {
      state.showSubRetailerUserDetailSidebar = value;
    },
    SET_SubRetailerSubmitting(state, value) {
      state.subRetailerSubmitting = value;
    },
    SET_SubRetailerUsersSubmitting(state, value) {
      state.subRetailerUsersSubmitting = value;
    },
    SELECT_SubRetailer(state, payload) {
      if (payload == null) {
        state.selectedSubRetailer = {
          subRetailerID: 0,
          retailerID: state.selectedRetailer.retailerID,
          name: "",
          branch: "",
          discountRate: 0,
          balance: 0,
          agentRate: 0,
          dealerRate: 0,
          sureloadRate: 0,
        };
      } else {
        const returnedTarget = Object.assign({}, payload);
        state.selectedSubRetailer = returnedTarget;
      }
    },
    SELECT_SubRetailerUser(state, payload) {
      if (payload == null) {
        state.selectedSubRetailerUser = {
          subRetailerUserID: 0,
          subRetailerID: state.selectedSubRetailer.subRetailerID,
          name: "",
          username: "",
          email: "",
          balance: 0,
        };
      } else {
        const returnedTarget = Object.assign({}, payload);
        state.selectedSubRetailerUser = returnedTarget;
      }
    },
    SET_TransactionsFilter(state, payload) {
      state.transactionsFilter = payload;
    },
    SET_BayadTransactionsFilter(state, payload) {
      state.bayadTransactionsFilter = payload;
    },
    SET_TopUps(state, payload) {
      state.topUps = payload;
    },
    SET_TopUpsLoading(state, isLoading) {
      state.topUpsLoading = isLoading;
    },
    SET_TopUpsExportLoading(state, status) {
      state.topUpsExportLoading = status;
    },
    SET_TopUpsFilter(state, payload) {
      state.topUpsFilter = payload;
    },
    SET_SubRetailer(state, payload) {
      state.subRetailer = {
        subRetailerID: payload.subRetailerID,
        retailerID: payload.retailerID,
        transactionType: payload.transactionType,
        name: payload.name,
        remainingBalance: payload.remainingBalance,
        earMarked: payload.earMarked,
        rebate: payload.rebate,
      };
    },
  },
  actions: {
    GetMasterDealer({ commit }) {
      commit("SET_MasterDealerLoading", true);
      commit("SET_MasterDealer", []);
      commit("FILTER_MasterDealers");

      return new Promise((resolve, reject) => {
        instance
          .get(`api/misc/masterDealer`, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_MasterDealer", response.data);
            commit("FILTER_MasterDealers");
            commit("SET_MasterDealerLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_MasterDealerLoading", false);
            reject(error.response);
          });
      });
    },
    GetMasterDealerTransactions({ commit, getters }) {
      commit("SET_TransactionsLoading", true);
      commit("SET_Transactions", []);
      var transactionsFilter = getters.transactionsFilter;
      const type = transactionsFilter.type.toLowerCase();

      // Handle "both" - fetch both Smart and Bayad transactions
      if (type === "both") {
        const smartEndpoint = `api/transaction/masterDealer/transactions?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`;
        const bayadEndpoint = `api/transaction/masterDealer/bayad?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`;

        return new Promise((resolve, reject) => {
          Promise.all([
            instance.get(smartEndpoint, {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }),
            instance.get(bayadEndpoint, {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }),
          ])
            .then(([smartResponse, bayadResponse]) => {
              // Add type field to each transaction
              const smartTransactions = (smartResponse.data || []).map(t => ({
                ...t,
                type: "Smart",
              }));
              const bayadTransactions = (bayadResponse.data || []).map(t => ({
                ...t,
                type: "Bayad",
              }));

              // Combine and sort by date
              const allTransactions = [...smartTransactions, ...bayadTransactions].sort(
                (a, b) => new Date(b.date) - new Date(a.date)
              );

              commit("SET_Transactions", allTransactions);
              commit("SET_TransactionsLoading", false);
              resolve(true);
            })
            .catch(function (error) {
              commit("SET_TransactionsLoading", false);
              reject(error.response);
            });
        });
      }

      // Determine which endpoint to use based on transaction type
      let endpoint = "";
      if (type === "bayad") {
        endpoint = `api/transaction/masterDealer/bayad?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`;
      } else {
        endpoint = `api/transaction/masterDealer/transactions?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`;
      }

      return new Promise((resolve, reject) => {
        instance
          .get(endpoint, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Transactions", response.data);
            commit("SET_TransactionsLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_TransactionsLoading", false);
            reject(error.response);
          });
      });
    },
    GetSmartBalance({ commit }) {
      commit("SET_Loading", true);

      return new Promise((resolve, reject) => {
        instance
          .get("api/smart/balance", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_SmartBalance", response.data.balance);
            commit("SET_Loading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Loading", false);
            reject(error.response);
          });
      });
    },
    GetRetailers({ commit, rootGetters }) {
      commit("SET_Loading", true);
      commit("SET_SubRetailerLoading", true);
      commit("SET_Retailers", []);
      commit("FILTER_Retailers");

      return new Promise((resolve, reject) => {
        instance
          .get("api/retailer", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            // Get the role from the admin module
            const role = rootGetters["adminController/admin"].role;
            let data = response.data;

            commit("SET_Retailers", data);
            commit("FILTER_Retailers");
            commit("SET_Loading", false);
            commit("SET_SubRetailerLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Loading", false);
            reject(error.response);
          });
      });
    },
    AddRetailer({ commit, getters }) {
      commit("SET_Submitting", true);

      return new Promise((resolve, reject) => {
        instance
          .post("api/retailer", getters.selectedRetailer, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Submitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },
    UpdateRetailer({ commit, getters }) {
      commit("SET_Submitting", true);

      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/retailer/${getters.selectedRetailer.retailerID}`,
            getters.selectedRetailer,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_Submitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },
    UpdateRetailerBalance({ commit, getters }, amount) {
      commit("SET_Submitting", true);
      var retailerID = getters.selectedRetailer.retailerID;

      return new Promise((resolve, reject) => {
        instance
          .post(
            `api/retailer/${retailerID}/topUp`,
            { amount },
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_Submitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },
    GetSubRetailers({ commit, getters }) {
      //commit("SET_ShowSubRetailer", false);
      commit("SET_SubRetailerLoading", true);
      commit("SET_SubRetailers", []);
      commit("FILTER_SubRetailers");

      return new Promise((resolve, reject) => {
        instance
          .get(`api/subretailer/${getters.selectedRetailer.retailerID}`, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_SubRetailers", response.data);
            commit("FILTER_SubRetailers");
            commit("SET_SubRetailerLoading", false);
            commit("SET_ShowSubRetailer", true);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_SubRetailerLoading", false);
            reject(error.response);
          });
      });
    },
    AddSubRetailer({ commit, getters }) {
      commit("SET_SubRetailerSubmitting", true);
      var retailerID = getters.selectedRetailer.retailerID;
      var subRetailer = getters.selectedSubRetailer;

      return new Promise((resolve, reject) => {
        instance
          .post(`api/subretailer/${retailerID}`, subRetailer, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_SubRetailerSubmitting", false);
            resolve(response.data);
          })
          .catch(function (error) {
            commit("SET_SubRetailerSubmitting", false);
            reject(error.response);
          });
      });
    },
    UpdateSubRetailer({ commit, getters }) {
      commit("SET_SubRetailerSubmitting", true);
      var retailerID = getters.selectedRetailer.retailerID;
      var subRetailer = getters.selectedSubRetailer;

      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/subretailer/${retailerID}/${subRetailer.subRetailerID}`,
            subRetailer,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_SubRetailerSubmitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_SubRetailerSubmitting", false);
            reject(error.response);
          });
      });
    },
    UpdateSubRetailerBalance({ commit, getters }, amount) {
      commit("SET_SubRetailerSubmitting", true);
      var retailerID = getters.selectedRetailer.retailerID;
      var subRetailer = getters.selectedSubRetailer;

      return new Promise((resolve, reject) => {
        instance
          .post(
            `api/retailer/${retailerID}/load/transfer/${subRetailer.subRetailerID}`,
            { amount },
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_SubRetailerSubmitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_SubRetailerSubmitting", false);
            reject(error.response);
          });
      });
    },

    TransferRebate({ commit }, { subRetailerID, amount }) {
      commit("SET_SubRetailerSubmitting", true);

      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/retailer/${subRetailerID}/rebate`,
            { Amount: amount },
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_SubRetailerSubmitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_SubRetailerSubmitting", false);
            reject(error.response);
          });
      });
    },

    GetSubRetailerUsers({ commit, getters }, subRetailerID = null) {
      commit("SET_SubRetailerUsersLoading", true);
      commit("SET_SubRetailerUsers", []);
      commit("FILTER_SubRetailersUser", []);
      var subRetailer = getters.selectedSubRetailer;

      const id = subRetailerID || subRetailer?.subRetailerID;

      return new Promise((resolve, reject) => {
        instance
          .get(`api/subretailer/${id}/user`, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_SubRetailerUsers", response.data);
            commit("FILTER_SubRetailersUser", []);
            commit("SET_SubRetailerUsersLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_SubRetailerUsersLoading", false);
            reject(error.response);
          });
      });
    },
    AddSubRetailerUsers({ commit, getters }, subRetailerID = null) {
      commit("SET_SubRetailerUsersSubmitting", true);
      var subRetailer = getters.selectedSubRetailer;
      var subRetailerUser = getters.selectedSubRetailerUser;

      const id = subRetailerID || subRetailer?.subRetailerID;

      return new Promise((resolve, reject) => {
        instance
          .post(`api/subretailer/${id}/user`, subRetailerUser, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_SubRetailerUsersSubmitting", false);
            resolve(response.data);
          })
          .catch(function (error) {
            commit("SET_SubRetailerUsersSubmitting", false);
            reject(error.response);
          });
      });
    },
    GetTransactions({ commit, getters }) {
      commit("SET_TransactionsLoading", true);
      commit("SET_Transactions", []);
      var transactionsFilter = getters.transactionsFilter;

      return new Promise((resolve, reject) => {
        instance
          .get(
            `api/subretailer/user/log/trail?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_Transactions", response.data);
            commit("SET_TransactionsLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_TransactionsLoading", false);
            reject(error.response);
          });
      });
    },
    GetBayadTransactions({ commit }, { dateFrom, dateTo }) {
      commit("SET_BayadTransactionsLoading", true);
      commit("SET_BayadTransactions", []);

      return new Promise((resolve, reject) => {
        instance
          .get(
            `api/transaction/bayad/all?FromDate=${dateFrom}&ToDate=${dateTo}`,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then((response) => {
            commit("SET_BayadTransactions", response.data || []);
            commit("SET_BayadTransactionsLoading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_BayadTransactionsLoading", false);
            reject(error.response);
          });
      });
    },
    ExportBayadTransactions({ commit, getters }) {
      commit("SET_BayadTransactionsExportLoading", true);
      const bayadFilter = getters.bayadTransactionsFilter;

      return new Promise((resolve, reject) => {
        instance
          .get(
            `api/transaction/bayad/all/export?FromDate=${bayadFilter.dateFrom}&ToDate=${bayadFilter.dateTo}`,
            {
              responseType: "blob",
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then((response) => {
            const filename = response.headers["content-disposition"]
              .split("; ")[1]
              .split("=")[1]
              .replace(/"/g, "");

            const url = URL.createObjectURL(
              new Blob([response.data], {
                type: "application/octet-stream",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            commit("SET_BayadTransactionsExportLoading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_BayadTransactionsExportLoading", false);
            reject(error.response);
          });
      });
    },
    GetAllTransactions({ commit }, { dateFrom, dateTo }) {
      commit("SET_AllTransactionsLoading", true);
      commit("SET_AllTransactions", []);

      return new Promise((resolve, reject) => {
        instance
          .get(`api/transaction/all?dateFrom=${dateFrom}&dateTo=${dateTo}`, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_AllTransactions", response.data || []);
            commit("SET_AllTransactionsLoading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_AllTransactionsLoading", false);
            reject(error.response);
          });
      });
    },
    GetTopUpHistory({ commit }, { dateFrom, dateTo }) {
      commit("SET_TopUpsLoading", true);
      commit("SET_TopUps", []);

      return new Promise((resolve, reject) => {
        instance
          .get("api/transaction/topups/all", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_TopUps", response.data);
            commit("SET_TopUpsLoading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_TopUpsLoading", false);
            reject(error.response);
          });
      });
    },
    ExportTopUpHistory({ commit, getters }) {
      commit("SET_TopUpsExportLoading", true);

      const topUpsFilter = getters.topUpsFilter;

      return new Promise((resolve, reject) => {
        instance
          .get(
            `api/transaction/topups/all/export?dateFrom=${topUpsFilter.dateFrom}&dateTo=${topUpsFilter.dateTo}`,
            {
              responseType: "blob",
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then((response) => {
            const filename = response.headers["content-disposition"]
              .split("; ")[1]
              .split("=")[1]
              .replace(/"/g, "");

            const url = URL.createObjectURL(
              new Blob([response.data], {
                type: "application/octet-stream",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            commit("SET_TopUpsExportLoading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_TopUpsExportLoading", false);
            reject(error.response);
          });
      });
    },
    ExportTransactions({ commit, getters }) {
      commit("SET_TransactionsExportLoading", true);
      var transactionsFilter = getters.transactionsFilter;

      return new Promise((resolve, reject) => {
        instance
          .get(
            `api/transaction/all/export?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`,
            {
              responseType: "blob",
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            var filename = response.headers["content-disposition"]
              .split("; ")[1]
              .split("=")[1]
              .replace(/"/g, "");
            const url = URL.createObjectURL(
              new Blob([response.data], {
                type: "application/octet-stream",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            commit("SET_TransactionsExportLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_TransactionsExportLoading", false);
            reject(error.response);
          });
      });
    },
    ExportTypeTransactions({ commit, getters }) {
      commit("SET_TransactionsExportLoading", true);
      const transactionsFilter = getters.transactionsFilter;
      const type = transactionsFilter.type.toLowerCase();

      // Determine which endpoint to use based on transaction type
      let endpoint = "";
      if (type === "bayad") {
        endpoint = `api/transaction/masterDealer/bayad/export?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`;
      } else {
        endpoint = `api/transaction/masterDealer/transactions/export?dateFrom=${transactionsFilter.dateFrom}&dateTo=${transactionsFilter.dateTo}`;
      }

      return new Promise((resolve, reject) => {
        instance
          .get(endpoint, {
            responseType: "blob",
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            var filename = response.headers["content-disposition"]
              .split("; ")[1]
              .split("=")[1]
              .replace(/"/g, "");
            const url = URL.createObjectURL(
              new Blob([response.data], {
                type: "application/octet-stream",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            commit("SET_TransactionsExportLoading", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_TransactionsExportLoading", false);
            reject(error.response);
          });
      });
    },
    DirectLoadSubscriber({ commit, getters }) {
      commit("SET_LoadSubscriberSubmitting", true);
      var retailerID = getters.selectedRetailer.retailerID;
      var loadSubscriber = getters.loadSubscriber;

      return new Promise((resolve, reject) => {
        instance
          .post(`api/retailer/${retailerID}/load/subscriber`, loadSubscriber, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_LoadSubscriberSubmitting", false);
            resolve(response.data);
          })
          .catch(function (error) {
            commit("SET_LoadSubscriberSubmitting", false);
            reject(error.response);
          });
      });
    },
    DeleteSubRetailerUser({ commit }, payload) {
      return new Promise((resolve, reject) => {
        instance
          .delete(
            `api/subretailer/${payload.subRetailerID}/user/${payload.subRetailerUserID}`,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            resolve(true);
          })
          .catch(function (error) {
            reject(error.response);
          });
      });
    },
    UpdateSubRetailerUserVisibility({ commit }, payload) {
      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/subretailer/${payload.subRetailerUserID}/user/visibility?isVisible=${payload.isVisible}`,
            null, // body
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            resolve(true);
          })
          .catch(function (error) {
            reject(error.response);
          });
      });
    },
    UpdateSubRetailerVisibility({ commit }, payload) {
      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/subretailer/${payload.subRetailerID}/visibility?isVisible=${payload.isVisible}`,
            null, // body
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            resolve(true);
          })
          .catch(function (error) {
            reject(error.response);
          });
      });
    },
    UpdateSubRetailerUserBalance({ commit, getters }, amount) {
      commit("SET_SubRetailerSubmitting", true);
      var subRetailerUserId = getters.selectedSubRetailerUser.subRetailerUserID;

      return new Promise((resolve, reject) => {
        instance
          .post(
            `api/subretailer/${subRetailerUserId}/topUp`,
            { amount },
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_SubRetailerSubmitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_SubRetailerSubmitting", false);
            reject(error.response);
          });
      });
    },

    UpdateSubRetailerUserDetails({ commit, getters }, subRetailerID = null) {
      commit("SET_SubRetailerUsersSubmitting", true);
      var subRetailer = getters.selectedSubRetailer;
      var subRetailerUser = getters.selectedSubRetailerUser;

      const id = subRetailerID || subRetailer?.subRetailerID;

      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/subretailer/${id}/user/${subRetailerUser.subRetailerUserID}`,
            subRetailerUser,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then(async function (response) {
            commit("SET_SubRetailerUsersSubmitting", false);
            resolve(response.data);
          })
          .catch(function (error) {
            commit("SET_SubRetailerUsersSubmitting", false);
            reject(error.response);
          });
      });
    },
    ChangeSubRetailerUserPassword({ commit }, payload) {
      commit("SET_SubRetailerUsersSubmitting", true);

      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/subretailer/user/password/${payload.subRetailerUserID}`,
            { newPassword: payload.newPassword },
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then((response) => {
            commit("SET_SubRetailerUsersSubmitting", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_SubRetailerUsersSubmitting", false);
            reject(error.response);
          });
      });
    },

    ChangeSubRetailerPassword({ commit }, payload) {
      commit("SET_SubRetailerSubmitting", true);

      return new Promise((resolve, reject) => {
        instance
          .put(
            `api/subretailer/password/${payload.subRetailerID}`,
            { newPassword: payload.newPassword },
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then((response) => {
            commit("SET_SubRetailerSubmitting", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_SubRetailerSubmitting", false);
            reject(error.response);
          });
      });
    },

    GetSubRetailerByID({ commit }, subRetailerID = null) {
      commit('SET_SubRetailerLoading', true);
      return new Promise((resolve, reject) => {
        instance
          .get(`api/retailer/${subRetailerID}`, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            localStorage.setItem("transactionType", response.data.transactionType);
            commit("SET_SubRetailer", response.data);
            commit('SET_SubRetailerLoading', false);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          })
          .finally(() => { 
            commit('SET_SubRetailerLoading', false);
          });
      });
    },
  },
};
